"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeUnitType = exports.IkeUnitAngle = exports.IkeUnitDistance = void 0;
exports.IkeUnitDistance = {
    FEET: 'feet',
    METER: 'meters',
    CENTIMETER: 'centimeters',
    MILLIMETER: 'millimeters',
    INCH: 'inches',
};
exports.IkeUnitAngle = {
    RADIAN: 'radians',
    DEGREE: 'degrees',
};
/** Supported types of units, Distance, Area or Angle */
exports.IkeUnitType = {
    DISTANCE: 'distance',
    AREA: 'area',
    ANGLE: 'angle',
};
//# sourceMappingURL=units.js.map